import axios from "axios";

export const getStoreDetails = ({ commit }, host) => {
  let baseUrl = "";
  let env = "";
  if (host.includes(".dev.") || host.includes("localhost")) env = "development";
  else if (host.includes(".homolog")) env = "homologation";
  else env = "production";
  switch (env) {
    case "production":
      baseUrl = "https://soulapi.blueticket.com.br/api/store/configs";
      break;
    case "homologation":
      baseUrl = "https://soulapi.homolog.btservers.com.br/api/store/configs";
      break;
    default:
      baseUrl = "https://soulapi.dev.btservers.com.br/api/store/configs";
  }
  if (host.includes("localhost")) {
    host = null;
  }
  return axios
    .get(baseUrl, {
      params: { host: host ? host.replace("https://", "") : undefined },
    })
    .then((response) => {
      if (response?.data?.apiUrl?.includes(".dev."))
        axios.defaults.baseURL =
          "https://soulapi.dev03.btservers.com.br" + "/api";
      else axios.defaults.baseURL = response.data.apiUrl + "/api";

      axios.defaults.headers.common["pdv"] = response.data.pdv;
      axios.defaults.headers.common["pos"] = response.data.pos;
      commit("SET_EVENT_POS", response.data.pdv);
      commit("SET_EVENT_PDV", response.data.pos);
      commit("SET_STORE_DETAILS", response.data);
      return response.data;
    });
};

export const getEventDetails = async ({ commit }, event) => {
  commit("SET_LOADING", true);
  return await axios
    .post(`/pdv/event/detail/${event}`)
    .then((response) => {
      if (response.status === 200) {
        if (response.data.data_cancelamento)
          commit("SET_ERROR_PRODUCTS", "Evento Cancelado");

        commit("SET_EVENT_DETAILS", response.data);
        commit("SET_MAX_PRODUCTS_PER_CPF", response.data.max_produtos_cpf);
        if (response.data.fila_ativa)
          commit("SET_QUEUE", {
            show: response.data.fila_ativa,
            text: response.data.fila_texto,
          });
      }
      commit("SET_LOADING", false);
    })
    .catch((error) => {
      if (error) {
        commit("SET_LOADING", false);
        commit("SET_EVENT_DETAILS", null);
      }
    });
};

export const handleAnalytics = ({ commit }, params) => {
  commit("CHECK");
  return axios.post(`analytics/visits`, {
    codigo_evento: params.event,
    url_pagina: params.url,
    terminal: params.ht,
    tipo_device: params.device,
    origem_referrer: params.referer,
  });
};

export const openSnackbar = ({ commit }, snackbarContent) => {
  commit("OPEN_SNACKBAR", snackbarContent);
};

export const resetPurchase = ({ commit }) => {
  commit("SET_ORDER_DETAILS", null);
  commit("SET_FINAL_DETAILS", null);
  commit("SET_BUYER_DATA", null);
  commit("SET_NOSECTOR_LIST", null);
  commit("SET_PRODUCTS_DETAILS", null);
};

export const setExpirationDialog = ({ commit }, value) => {
  commit("SET_EXPIRATION_DIALOG", value);
};

export const getOrderDetails = async ({ commit }, hash) => {
  commit("SET_LOADING", true);
  return await axios
    .get(`/orders/continue?hash=${hash}`)
    .then((response) => {
      if (response.status === 200) {
        const { data } = response;
        axios.defaults.headers.common["pdv"] = data.pdv;
        axios.defaults.headers.common["pos"] = data.pos;

        if (Number(data.valor_total) > data.valor_pago) {
          if (!data.valor_pago) commit("SET_FIRST_PAYMENT");
          commit("SET_PENDING_ORDER", true);
        }

        if (data?.ingressos[0]?.dados_extras[0]?.valor) {
          commit("SET_NAMED_TICKETS", true);
        }

        commit("SET_ORDER_PRODUCTS", data.produtos_array);
        commit("SET_ORDER_DETAILS", data);
        commit("SET_LOADING", false);
        return response;
      } else return response;
    })
    .catch(() => {
      commit("SET_LOADING", false);
    });
};

export const getQueue = ({ commit }, params) => {
  commit("CHECK");
  return axios
    .get(`queue/session/${params.event}/${params.uuid}`)
    .then((resp) => {
      return resp;
    });
};
